import { rpx } from '@/utils'
import './prop.scss'
import { Tooltip } from 'react-tooltip'
import { randomCode } from '@base/lang'

interface PropProps {
  level: CouponLevel
  name: string
  imgSrc: string
  count: number
  get: boolean
  desc: string
}
export default function Prop(props: PropProps) {
  const { level, name, imgSrc, count, get, desc } = Object.assign({}, props)
  const countStyle: React.CSSProperties = {
    display: get ? 'none' : 'block',
    backgroundColor: {
      1: '#7bbff1',
      2: '#d568f6',
      3: '#eab93a',
    }[level],
  }
  const getStyle: React.CSSProperties = {
    display: get ? 'block' : 'none',
  }

  const keyName = `prop-${level}-${count}-${randomCode(10)}`

  return (
    <div className="prop-box">
      <div className={`prop ${keyName}`}>
        <img src={imgSrc} alt=" " />
        <div className={`border border--${level}`}></div>
        <i style={countStyle}>{count}</i>
        <div className="prop-get" style={getStyle}></div>
      </div>
      <Tooltip
        anchorSelect={`.${keyName}`}
        place="top"
        style={{
          zIndex: '4',
          padding: rpx(10),
          maxWidth: rpx(384),
          background: 'rgba(0, 0, 0, 0.8)',
        }}
        positionStrategy="fixed"
        openEvents={{ click: true }}
      >
        <div className="prop-name">{props.name}</div>
        {props.desc ? <div className="prop-desc">{props.desc}</div> : null}
      </Tooltip>
    </div>
  )
}
